//File imports
import HttpService from '../../../services/Http/HttpService';
import Logger from '../../../services/Logger/Logger';
import { API_GET_ALL_SEARCH_KEYWORDS } from './KeywordConstants';
import KeywordResultsPojo from './KeywordResultPojo';

export class KeywordService {
    private httpService = new HttpService();
    private logger = new Logger();

    async getAllKeywords(): Promise<KeywordResultsPojo> {
        try {
            const httpResult = await this.httpService.get(
                API_GET_ALL_SEARCH_KEYWORDS,
                {},
            );
            return {
                isSuccess: httpResult.data.isSuccess,
                keywords: httpResult.data.response,
            };
        } catch (e) {
            this.logger.error(e);
            throw e;
        }
    }
}
